module.exports = __webpack_public_path__ + "img/8.2d62030a.jpg";